const locale = {
  SESSION_TIMEOUT_WARNING_TITLE: 'Advertencia de Tiempo de Sesión',
  SESSION_TIMEOUT_WARNING_DESCRIPTION: 'Tu sesión expirará en 5 minutos por inactividad.',
};

export default locale;
